module.exports = __webpack_public_path__ + "static/img/home_show.ceed449.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pic/home_show.png
// module id = Pgkc
// module chunks = 1